import React from 'react';
import { useTranslation } from 'react-i18next';

interface LanguageToggleProps {
  className?: string;
  variant?: 'light' | 'dark';
}

const LanguageToggle: React.FC<LanguageToggleProps> = ({ className = '', variant = 'light' }) => {
  const { i18n, t } = useTranslation();

  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    void i18n.changeLanguage(event.target.value);
  };

  const baseClasses =
    'inline-flex items-center gap-2 rounded-full border px-3 py-1 text-xs font-semibold transition focus-visible:outline-none focus-visible:ring-2';

  const variants: Record<NonNullable<LanguageToggleProps['variant']>, string> = {
    light: 'border-slate-200 bg-white/80 text-slate-600 focus-visible:ring-brand-primary/40',
    dark: 'border-white/20 bg-white/10 text-white focus-visible:ring-white/60'
  };

  return (
    <label className={`inline-flex items-center gap-2 ${className}`}>
      <span className="sr-only">{t('language.switcherLabel')}</span>
      <select
        value={i18n.language}
        onChange={handleChange}
        className={`${baseClasses} ${variants[variant]}`}
      >
        <option value="id">{t('language.indonesian')}</option>
        <option value="en">{t('language.english')}</option>
      </select>
    </label>
  );
};

export default LanguageToggle;
